module.exports = __webpack_public_path__ + "static/media/puzzle-heart.2122ec0e.svg";